import { render, staticRenderFns } from "./viewDollarRate.vue?vue&type=template&id=e3873ffa&scoped=true&"
import script from "./viewDollarRate.vue?vue&type=script&lang=js&"
export * from "./viewDollarRate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3873ffa",
  null
  
)

export default component.exports